import { Card, FormControl, Typography } from '@mui/material';
import styled from 'styled-components';
import mediaQueries from 'utils/mediaQueries';

const { small } = mediaQueries;

export const StyledCard = styled(Card)`
  box-shadow: none;
  border: none;
`;

export const WidgetTitle = styled(Typography)`
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 20px;
`;

export const WidgetDescription = styled(Typography)`
  margin-bottom: 24px;
  color: #666;
`;

export const PreviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 200px;
  margin-bottom: 24px;
  border: 1px dashed #007bff;
  border-radius: 4px;
  background-color: #f0f7ff;
  color: #007bff;
  gap: 8px;

  svg {
    font-size: 48px;
  }
`;

export const StyledFormControl = styled(FormControl)`
  width: 100%;
  margin-bottom: 24px;
`;

export const OptionsToggle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  color: #666;
  font-size: 14px;
  cursor: pointer;

  svg {
    margin-left: 4px;
  }
`;

export const OptionsSection = styled.div`
  margin-bottom: 24px;
  padding: 8px;
`;

export const InputsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;

  @media ${small} {
    flex-direction: column;
  }
`;

export const InputWrapper = styled.div`
  flex: 1;
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

export const OfficialsLookupWidgetCheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;
